//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useEffect, useContext, useState, useCallback, useRef } from 'react';

// custom pages
import DashboardAPI from 'apis/dashboard/dashboard';
import MilestoneTrackingAPI from 'apis/MilestoneTracking/MilestoneTracking'; // NEW: for the growth bonus box
import { pointCardStyles } from './style';
import Loader from 'components/Loader/Loader';
import Context from 'context/context';
import { useTranslation } from 'react-i18next';
import HistoryTable from "components/Table/History/HistoryTable";
import * as moment from "moment";
import Dialog from "@material-ui/core/Dialog";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper"
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import { withStyles } from '@material-ui/styles';
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import Tooltip from '@material-ui/core/Tooltip';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'; // NEW: arrow on "View Growth Bonus Details"
import BenefitMetricCard  from 'views/Dashboard/Dashboard/Components/PointsMetrics'
// material-ui
import Grid from '@material-ui/core/Grid';
import {useTrackWithGTM} from 'helpers/gtm';


// helpers
import { dateFormat, pointsFormat } from "helpers/dataFormat";
import { logEvent } from "../../../../helpers/analytics";

// 1 Thrive Rewards point = $0.005 (so a $500 bonus = 100,000 Growth Bonus Points).
const POINT_VALUE = 0.005;

const GrowthInfoTooltip = withStyles({
  tooltip: {
    color: '#111827',
    backgroundColor: '#e8eaeb',
    maxWidth: 380,
    fontSize: 12,
    lineHeight: 1.45,
    fontFamily: "'DM Sans', sans-serif",
  },
  arrow: {
    '&:before': {
      backgroundColor: '#e8eaeb',
    },
  },
})(Tooltip);

function useCountUp(target, active, duration = 900) {
  const [value, setValue] = useState(0);
  const frameRef = useRef(null);

  useEffect(() => {
    if (!active) return undefined;

    const startTime = performance.now();
    const endValue = Number(target) || 0;

    const tick = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(1, elapsed / duration);
      const eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
      setValue(Math.round(endValue * eased));
      if (progress < 1) {
        frameRef.current = requestAnimationFrame(tick);
      }
    };

    frameRef.current = requestAnimationFrame(tick);
    return () => {
      if (frameRef.current) cancelAnimationFrame(frameRef.current);
    };
  }, [target, active, duration]);

  return value;
}

export default function PointsCard({ loyaltyId,showThriveUnlocked }) {
  const [states, setstates] = useState({
    historyLoader: false,
  });
  const history = useHistory();
  const { state, dispatch } = useContext(Context);
  const { getPoints } = DashboardAPI();
  const classes = pointCardStyles();
  const { t, i18n } = useTranslation();
  const [rows, setrows] = useState([]);
  const [openmodel, setopenmodel] = useState(true);
    const { trackWithGTM } = useTrackWithGTM();


  const popupStartTimeRef = useRef(null); // ref to store popup start time

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(() => {
    if (state.ALA && Object.keys(state.ALA).length > 0) {
      handleGetPoints();
      return;
    }
  }, [state.ALA]);

  console.log(showThriveUnlocked,"showThriveUnlocked")

  console.log(loyaltyId,"loyaltyId")

  const handleGetPoints = async () => {
    dispatch({ type: 'SET_LOADING', payload: true });
    try {
      let value = state.ALA.loyalty_id;
      setStates({ loading: true });
      let res = await getPoints(loyaltyId);
      if (res) {
        setStates({ points: res });
        setrows(res.allmonthexpireddate);
        dispatch({ type: 'SET_POINTS_BALANCE', payload: res });
        dispatch({ type: 'SET_DYNAMIC_DOLLAR', payload: res?.dollarSymbol });
        dispatch({ type: 'SET_LOADING', payload: false });
        return;
      }
    } catch (e) {
      console.log({ e });
    }
  };

  let GreenTooltip;
  if (states?.points?.availableToRedeem <= 0 && states?.points?.pointsBalance < 0 && state?.userInfo?.loyalty_organization_name === "Henry Schein Dental") {
    GreenTooltip = withStyles({
      tooltip: {
        color: "black",
        backgroundColor: "#e8eaeb",
        width: "500px",
        fontSize: "12px",
      },
      arrow: {
        "&:before": {
          backgroundColor: "#e8eaeb",
        },
      },
    })(Tooltip);
  }

  GreenTooltip = withStyles({
    tooltip: {
      color: "black",
      backgroundColor: "#e8eaeb",
      width: "500px",
      fontSize: "12px",
    },
    arrow: {
      "&:before": {
        backgroundColor: "#e8eaeb",
      },
    },
  })(Tooltip);

  const total = rows?.map(item => item.total_expired);


  const pointsBalance = states?.points?.pointsBalance ?? 0;
  const availableToRedeem = states?.points?.availableToRedeem ?? 0;

  const isHSD =
    state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" &&
    state?.userInfo?.loyalty_site_id == "henryschein.com";

  // $ conversion — 0.005 per point, 2 decimals. HSD only.
  const toDollar = (points) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(points || 0) * POINT_VALUE);


  const isNegativeBalance = isHSD && availableToRedeem <= 0 && pointsBalance < 0;
  const isNoneAvailable = isHSD && !isNegativeBalance && availableToRedeem === 0 && pointsBalance > 0; // four_page
  const isZeroBalance = isHSD && !isNegativeBalance && pointsBalance === 0; // second_page
  const isPartialAvailable = isHSD && !isNegativeBalance && availableToRedeem > 0 && availableToRedeem < pointsBalance; // third_page
  const isSameBalanceAvailable = isHSD && !isNegativeBalance && pointsBalance > 0 && pointsBalance === availableToRedeem; // first_page
  const isThriveUnlocked = state?.ACA?.unlocked_flag === true;
  const isSignature = state?.ACA?.signature_flag === true && !state?.ACA?.unlocked_flag;
  const isStartup = state?.ACA?.startup_flag === true;
  const isThrive = !isStartup && !isThriveUnlocked && !isSignature;

  console.log(state?.ACA, "data")
  const { shiptomilestoneView, getMilestoneConfig } = MilestoneTrackingAPI();

  const [growthBonusData, setGrowthBonusData] = useState(null);
  const [growthBonusMilestones, setGrowthBonusMilestones] = useState([]);
  const [growthBonusLoading, setGrowthBonusLoading] = useState(false);
  const [growthBonusLoaded, setGrowthBonusLoaded] = useState(false);
  const growthBonusShipTo = state?.ACA?.customer_account_number;

  useEffect(() => {
    if (!isThriveUnlocked || !growthBonusShipTo) return;

    let cancelled = false;

    (async () => {
      setGrowthBonusLoading(true);
      try {
        const configRes = await getMilestoneConfig();
        if (!cancelled && configRes?.data && Array.isArray(configRes.data) && configRes.data.length > 0) {
          const sorted = [...configRes.data].sort((a, b) => a.milestone_value - b.milestone_value);
          setGrowthBonusMilestones(sorted.map((m) => Number(m.milestone_value)));
        }

        const res = await shiptomilestoneView({ customer_account_number: growthBonusShipTo });
        if (!cancelled && res?.data) {
          setGrowthBonusData(res.data);
        }
      } catch (e) {
        console.log({ e });
      } finally {
        if (!cancelled) {
          setGrowthBonusLoading(false);
          setGrowthBonusLoaded(true);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [isThriveUnlocked, growthBonusShipTo]);

  const gbSpend = Number(growthBonusData?.netQualifyingSpend || 0);
  const gbBonusEarned = Number(growthBonusData?.bonusDollar || 0);
  const gbBonusPerMilestone = 500;
  const gbHasMilestones = growthBonusMilestones.length > 0;
  const gbTotalMilestones = growthBonusMilestones.length;
  const gbMaxValue = gbHasMilestones
    ? growthBonusMilestones[growthBonusMilestones.length - 1]
    : 0;
  const gbFirstMilestone = growthBonusMilestones[0] || 10000;
  const gbStepAmount = growthBonusMilestones.length > 1
    ? growthBonusMilestones[1] - growthBonusMilestones[0]
    : 5000;
  const gbPrevMilestone = [...growthBonusMilestones].reverse().find((m) => gbSpend >= m) || 0;
  const gbNextMilestone = growthBonusMilestones.find((m) => gbSpend < m) || null;
  const gbAllMilestonesReached = gbHasMilestones && gbNextMilestone === null;
  const gbSegmentStart = gbPrevMilestone;
  const gbSegmentEnd = gbNextMilestone || gbMaxValue;
  const gbSegmentPct = gbHasMilestones && gbSegmentEnd > gbSegmentStart
    ? Math.min(100, Math.max(0, Math.round(((gbSpend - gbSegmentStart) / (gbSegmentEnd - gbSegmentStart)) * 100)))
    : gbAllMilestonesReached ? 100 : 0;
  const gbToNext = gbNextMilestone ? gbNextMilestone - gbSpend : 0;
  const gbPointsEarned = Number(growthBonusData?.bonusPoints || 0);
  const gbMilestonesReached = Number(growthBonusData?.milestonesHit || 0);
  // Max-state totals (config-based; no API field exists for these yet).
  const gbMaxBonusDollars = gbTotalMilestones * gbBonusPerMilestone; // e.g. 21 x $500 = $10,500
  const gbMaxBonusPoints = Math.round(gbMaxBonusDollars / POINT_VALUE); // e.g. 2,100,000

  const gbShowLoading = growthBonusLoading || !growthBonusLoaded;
  const animatedSpend = useCountUp(gbSpend, !gbShowLoading);
  const animatedPoints = useCountUp(gbPointsEarned, !gbShowLoading);
  const animatedBonus = useCountUp(gbBonusEarned, !gbShowLoading);
  const animatedToNext = useCountUp(gbToNext, !gbShowLoading);

  const goToGrowthBonusDetails = () => {
    if (!growthBonusShipTo) {
      console.warn('Growth Bonus: no customer_account_number available, not navigating.');
      return;
    }
    history.push('/dashboard/growth-bonus', {
      data: {
        ...growthBonusData,
        customer_account_number: growthBonusShipTo,
      },
    });
  };

  const GB_BLUE = '#2563eb';
  const GB_BLUE_BORDER = '#93c5fd';
  const GB_BLUE_BG = '#eaf3ff'; // light-blue callout background
  const GB_TRACK = '#e5e7eb';
  const GB_TITLE = '#0f172a';
  const GB_LABEL = '#6b7280';
  const GB_VALUE = '#111827';
  const GB_FONT = "'DM Sans', sans-serif";


  return (
    <>
      <Grid container spacing={0} style={{ textAlign: 'center' }} >
        <Grid container item lg={12} spacing={2} >
          <Grid item md={4} xs={12}>
            <div className={classes.card}>
              {isNegativeBalance ? (
                // Existing negative-balance case — unchanged
                <GreenTooltip
                  title={t(
                    "Returning items reduces your points. If your balance falls below zero after a redemption, and remains negative for over 90 days, you may be charged for the outstanding amount."
                  )}
                  placement="bottom"
                  arrow
                >
                  <div>
                    <div className={classes.pointsText}>{t('Points Balance')}</div>
                    <div className={classes.pointsValue} style={{ fontSize: 25 }}>
                      <Loader Loading={state.loading}>
                        {pointsFormat(pointsBalance, i18n.language)}
                      </Loader>
                    </div>
                    <div style={{ fontSize: 18 }}>
                      ({toDollar(pointsBalance)})
                    </div>
                    <button onClick={() => {
                      history.push("/dashboard/redeem");
                    }} className={classes.redeemnew}>
                      {t('Redeem My Points')}
                    </button>
                  </div>
                </GreenTooltip>

              ) : isNoneAvailable ? (
                // four_page: available to redeem = 0, balance > 0

                <div>
                  <div className={classes.pointsText}>
                    {t('Points Balance')}
                  </div>

                  <div
                    className={classes.pointsValue}
                    style={{ fontSize: 25 }}
                  >
                    <Loader Loading={state.loading}>
                      {pointsFormat(pointsBalance, i18n.language)}
                    </Loader>
                  </div>

                  <div style={{ fontSize: 18 }}>
                    ({toDollar(pointsBalance)})
                  </div>

                  <div
                    style={{
                      width: '100%',
                      height: '1px',
                      backgroundColor: '#ddd',
                      margin: '10px 0',
                    }}
                  />

                  <div
                    style={{
                      fontSize: 12,
                      color: '#666',
                      marginTop: 4,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 4,
                    }}
                  >
                    <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                      {t('No eligible purchases are currently available for redemption')}{' '}
                      <GreenTooltip
                        title={t(
                          "Your available redemption amount is based on eligible products purchased within the past 90 days. Points may be applied toward up to 50% of those purchases."
                        )}
                        placement="bottom"
                        arrow
                      >
                        <InfoOutlinedIcon style={{ fontSize: 15, color: '#0a72ba', marginLeft: -2, cursor: 'pointer' }} />
                      </GreenTooltip>
                    </span>
                  </div>
                </div>


              ) : isZeroBalance ? (
                // second_page: balance = 0 -> plain display, no button
                <div>
                  <div className={classes.pointsText}>{t('Points Balance')}</div>
                  <div className={classes.pointsValue} style={{ fontSize: 25 }}>
                    <Loader Loading={state.loading}>
                      {pointsFormat(pointsBalance, i18n.language)}
                    </Loader>
                  </div>
                  <div style={{ fontSize: 18 }}>({toDollar(pointsBalance)})</div>
                </div>

              ) : isPartialAvailable ? (
                // third_page: available to redeem < balance -> show both + Redeem button
                <div>
                  <div className={classes.pointsText}>{t('Points Balance')}</div>
                  <div className={classes.pointsValue} style={{ fontSize: 25 }}>
                    <Loader Loading={state.loading}>
                      {pointsFormat(pointsBalance, i18n.language)}
                    </Loader>
                  </div>
                  <div style={{ fontSize: 18, marginBottom: 8 }}>({toDollar(pointsBalance)})</div>

                  <div
                    style={{
                      width: '100%',
                      height: '1px',
                      backgroundColor: '#ddd',
                      margin: '10px 0',
                    }}
                  />

                  <div style={{ marginTop: 8 }}>
                    <span className={classes.pointsText}>
                      {t('Available to Redeem Now')}{' '}
                      <GreenTooltip
                        title={t(
                          "Your available redemption amount is based on eligible products purchased within the past 90 days. Points may be applied toward up to 50% of those purchases."
                        )}
                        placement="top"
                        arrow
                      >
                        <InfoOutlinedIcon style={{ fontSize: 15, color: '#0a72ba', marginLeft: -4, cursor: 'pointer' }} />
                      </GreenTooltip>
                    </span>
                    <div className={classes.pointsValue} style={{ fontSize: 20 }}>
                      {pointsFormat(availableToRedeem, i18n.language)}
                    </div>
                    <div style={{ fontSize: 18 }}>({toDollar(availableToRedeem)})</div>
                  </div>

                  <button onClick={() => {
                    history.push("/dashboard/redeem");
                  }} className={classes.redeemnew}>
                    {t('Redeem My Points')}
                  </button>
                </div>

              ) : isSameBalanceAvailable ? (
                // first_page: balance === available to redeem -> simple + Redeem button
                <div>
                  <div className={classes.pointsText}>{t('Points Balance')}</div>
                  <div className={classes.pointsValue} style={{ fontSize: 25 }}>
                    <Loader Loading={state.loading}>
                      {pointsFormat(pointsBalance, i18n.language)}
                    </Loader>
                  </div>
                  <div style={{ fontSize: 18 }}>
                    ({toDollar(pointsBalance)})
                  </div>
                  <button onClick={() => {
                    history.push("/dashboard/redeem");
                  }} className={classes.redeemnew}>
                    {t('Redeem My Points')}
                  </button>
                </div>

              ) : (
                // Non-HSD orgs / fallback -> original behavior, untouched
                <div>
                  <div className={classes.pointsText}>{t('Points Balance')}</div>
                  <div className={classes.pointsValue} style={{ fontSize: 25 }}>
                    <Loader Loading={state.loading}>
                      {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental"
                        ? (states.points && states.points.pointsBalance
                          ? pointsFormat(states.points.pointsBalance, i18n.language)
                          : 0)
                        : (states.points && states.points.pointsBalance > 0
                          ? pointsFormat(states.points.pointsBalance, i18n.language)
                          : 0)}
                    </Loader>
                  </div>

                </div>
              )}
            </div>
          </Grid>

          <Grid item md={4} xs={12}>
            <div className={isHSD && isPartialAvailable ? `${classes.card} ${classes.cardCompact}` : classes.card}>
              <div>
                <span
                  style={{ width: '100%', display: 'inline-block' }}
                  className={classes.pointsText}
                >
                  {t('Points Redeemed')}
                  {/* {(state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" && state?.ACA?.signature_flag !== true) ? (
                  <GreenTooltip title={t(`Redeem at least once every 12 months to keep your points active. Otherwise, your points balance will expire and you'll stop earning new points`)} placement="top" arrow>
                    <InfoOutlinedIcon style={{ fontSize: 15, color: '#0a72ba', marginLeft: 3 }} />
                  </GreenTooltip>
                ) : null} */}
                </span>{' '}
                <span
                  style={{
                    width: '100%',
                    display: 'inline-block',
                    fontSize: 14,
                  }}
                  className={classes.pointsText}
                >
                  {t('Last 12 Months')}
                </span>
              </div>

              <div className={classes.pointsValue}>
                <Loader Loading={state.loading}>
                  {states.points && states.points.pointsRedeemed
                    ? pointsFormat(states.points.pointsRedeemed, i18n.language)
                    : 0}
                </Loader>
              </div>
              {isHSD && (
                <div style={{ fontSize: 18 }}>({toDollar(states?.points?.pointsRedeemed)})
                </div>

              )}

              {(isPartialAvailable || isSameBalanceAvailable || isNoneAvailable) && (
                <a
                  target="_blank"
                  style={{
                    cursor: "pointer",
                    color: "#0a72ba",
                    fontSize: "14px",
                    fontFamily: "inherit",
                    textDecoration: "underline",
                  }}
                  onClick={() => {
                    history.push('/dashboard/dashboard', {
                      redeemed: 'pendingRedeemed',
                    });
                  }}
                >
                  {t("View Redemption Activity")}
                </a>
              )}
            </div>
          </Grid>

          <Dialog
            aria-labelledby="simple-dialog-title"
            open={states.historyDialog ? true : false}
            style={{ fontFamily: "Segoe-ui" }}
            maxWidth={false}
          >
            <div className={classes.dialogParentDiv}>
              <div
                className={classes.parentText}
                style={{
                  paddingBottom: 10,
                }}
              >
                <span style={{ float: "right" }}>
                  <HighlightOffIcon
                    style={{
                      cursor: "pointer",
                      color: "red",
                      fontSize: 28,
                      marginLeft: "-40%",
                      marginTop: "2%"
                    }}
                    onClick={() => {
                      const popupEndTime = new Date();

                      // Send analytics event when popup closes
                      logEvent({
                        event_type: "popup_view",
                        event_name: "Expiration Schedule",
                        user_id: state?.userInfo?.user_id || null,
                        session_id: state?.userInfo?.session_id || null,
                        timestamp_client: Date.now(),
                        start_time: popupStartTimeRef.current ? popupStartTimeRef.current.toISOString() : null,
                        end_time: popupEndTime.toISOString(),
                      });

                      setStates({ historyDialog: false, historyData: [] });
                    }}
                  />
                </span>
                <div className={classes.dialogParentDiv}>
                  <div
                    className={classes.parentText}
                    style={{
                      paddingBottom: 10,
                      width: rows?.length > 0 ? "100%" : 300,
                    }}
                  >
                  </div>
                  {rows && rows?.length > 0 ? (
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead style={{ backgroundColor: "#05395c" }}>
                          <TableRow>
                            <TableCell align="right" style={{ color: "white" }}>{t("Expiration Date")}</TableCell>
                            <TableCell align="right" style={{ color: "white" }}>{t("Points Due to Expire")}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.map((d, i) => (
                            <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                              <TableCell align="right">{dateFormat(d?.expireddate, i18n.language)}</TableCell>
                              <TableCell align="right">{pointsFormat(d?.expired, i18n.language)}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : null}
                </div>
              </div>
            </div>
          </Dialog>

          <Grid item md={4} xs={12}>
            <div className={isHSD && isPartialAvailable ? `${classes.card} ${classes.cardCompact}` : classes.card}>
              <div>
                {/* "Points Due to Expire" — lowercase "to" per business feedback */}
                <span
                  style={{ width: '100%', display: 'inline-block' }}
                  className={classes.pointsText}
                >
                  {t('Points Due to Expire')}
                </span>
                {state?.ALA?.["Loyalty_Account.points_not_expiring"] != true && <span
                  style={{
                    width: '100%',
                    display: 'inline-block',
                    fontSize: '14px',
                    fontWeight: 'bold',
                  }}
                >
                  <Loader Loading={state.loading}>
                    {states.points && states.points.pointsExpireOnDate
                      ? `(${dateFormat(states.points.pointsExpireOnDate, i18n.language)})`
                      : ''}
                  </Loader>
                </span>}
              </div>
              <div className={classes.pointsValue}>
                {state?.ALA?.["Loyalty_Account.points_not_expiring"] != true ? <Loader Loading={state.loading}>
                  {states.points && states.points.pointsExpireOnMonth
                    ? pointsFormat(states.points.pointsExpireOnMonth, i18n.language)
                    : 0}
                </Loader> : <Loader>{i18n?.language == "fr" ? "S.O." : "N/A"}</Loader>}
              </div>
              {isHSD && state?.ALA?.["Loyalty_Account.points_not_expiring"] != true && (
                <div style={{ fontSize: 18 }}>({toDollar(states?.points?.pointsExpireOnMonth)})</div>
              )}
              {state?.ALA?.["Loyalty_Account.points_not_expiring"] === true || states?.points?.pointsBalance === 0 || rows?.length === 0 ? (
                <></>
              ) : <>
                <a
                  target="_blank"
                  style={{ cursor: "pointer", color: "#0a72ba", fontSize: "14px", fontFamily: "inherit", textDecoration: "underline" }}
                  onClick={() => {
                    popupStartTimeRef.current = new Date(); // record start time
                    setStates({
                      historyDialog: true,
                      historyLoader: true,
                    });
                  }}
                >
                  {t("See Expiration Schedule")}
                </a>
              </>}
            </div>
          </Grid>
        </Grid>
      </Grid>

      {/* ===================================================================
        THRIVE UNLOCKED: GROWTH BONUS POINTS BOX
        =================================================================== */}
      {showThriveUnlocked !== false && isThriveUnlocked  && (
        <>
          <style>{`
          @keyframes gbFadeInUp {
            from { opacity: 0; transform: translateY(8px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes gbShimmer {
            0% { transform: translateX(-150%); }
            100% { transform: translateX(250%); }
          }
          @keyframes gbPulseGlow {
            0%, 100% { box-shadow: 0 0 0 0 rgba(22,163,74,0.25); }
            50% { box-shadow: 0 0 0 6px rgba(22,163,74,0); }
          }
          .gb-cta-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 14px rgba(37,99,235,0.28) !important;
          }
        `}</style>
          <Grid container spacing={0} style={{ marginTop: 28 }}>
            <Grid item xs={12}>
              <div
                style={{
                  background: '#ffffff',
                  border: `1px solid ${GB_BLUE_BORDER}`,
                  borderRadius: 12,
                  padding: '22px 26px',
                  textAlign: 'left',
                  fontFamily: GB_FONT,
                  animation: 'gbFadeInUp 0.5s ease-out',
                }}
              >
                {/* CHANGE 1: widget title */}
                <div style={{ fontWeight: 700, fontSize: 17, color: GB_TITLE, lineHeight: 1.3, fontFamily: GB_FONT, letterSpacing: '-0.01em' }}>
                  {t('Thrive Unlocked: Growth Bonus Points')}
                </div>
                {/* CHANGE 2: subheading aligned with the detail page */}
                <div style={{ fontSize: 13, fontWeight: 400, color: GB_LABEL, marginTop: 4, marginBottom: 22, fontFamily: GB_FONT }}>
                  {t('Earn ${{bonus}} in bonus points when you reach ${{first}} in qualifying merchandise spend, then ${{bonus}} more every ${{step}}.', {
                    bonus: gbBonusPerMilestone,
                    first: gbFirstMilestone.toLocaleString(),
                    step: gbStepAmount.toLocaleString(),
                  })}
                </div>

                {/* Three equal columns. Columns 1 & 2 stay centered; column 3
                  is a light-blue callout to match the reference design. */}
                <Grid container alignItems="stretch">
                  <Grid item xs={12} sm={4} style={{ textAlign: 'center', padding: '0 16px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    {/* No gap between the label and the info icon (icon sits directly after the text). */}
                    <div style={{ fontSize: 14, fontWeight: 400, color: GB_LABEL, fontFamily: GB_FONT, display: 'inline-flex', alignItems: 'center', gap: 0 }}>
                      {t('Qualifying Merchandise Spend')}
                      <GrowthInfoTooltip
                        title={t('Includes eligible merchandise purchases invoiced during your Thrive Unlocked program period. Returns and credits reduce your qualifying spend. Exclusions include OraPharma (Arestin), Colgate products, small equipment, handpieces, pharmaceuticals, refurbished equipment, taxes, shipping, service-related fees, and other non-qualifying items.')}
                        placement="top"
                        arrow
                      >
                        <InfoOutlinedIcon style={{ fontSize: 15, color: GB_BLUE, cursor: 'pointer', marginLeft: 2 }} />
                      </GrowthInfoTooltip>
                    </div>
                    <div style={{ fontSize: 28, fontWeight: 700, color: GB_VALUE, marginTop: 6, fontFamily: GB_FONT, letterSpacing: '-0.02em' }}>
                      <Loader Loading={gbShowLoading}>
                        ${animatedSpend.toLocaleString()}
                      </Loader>
                    </div>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={4}
                    style={{
                      textAlign: 'center',
                      padding: '0 16px',
                      position: 'relative',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <div style={{ position: 'absolute', left: 0, top: '9%', bottom: '9%', width: 1, background: GB_TRACK }} />
                    {/* CHANGE 3: points-first; the dollar value now sits on its own line
                        underneath the points, same placement as the Points Balance widget. */}
                    <div style={{ fontSize: 14, fontWeight: 400, color: GB_LABEL, fontFamily: GB_FONT }}>
                      {t('Growth Bonus Points Earned')}
                    </div>
                    <div style={{ fontSize: 28, fontWeight: 700, color: GB_VALUE, marginTop: 6, fontFamily: GB_FONT, letterSpacing: '-0.02em' }}>
                      <Loader Loading={gbShowLoading}>
                        {animatedPoints.toLocaleString()}
                      </Loader>
                    </div>
                    {!gbShowLoading && (
                      <div style={{ fontSize: 18, fontWeight: 400, color: GB_VALUE, marginTop: 2, fontFamily: GB_FONT }}>
                        (${animatedBonus.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})
                      </div>
                    )}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={4}
                    style={{
                      textAlign: 'left',
                      padding: '0 0 0 32px',
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'stretch',
                      justifyContent: 'flex-start',
                    }}
                  >
                    <div style={{ position: 'absolute', left: 0, top: '9%', bottom: '9%', width: 1, background: GB_TRACK }} />
                    {gbShowLoading ? null : gbAllMilestonesReached ? (
                      /* CHANGE 5: maximum-reached state replaces the right-hand card */
                      <div
                        style={{
                          background: GB_BLUE_BG,
                          borderRadius: 8,
                          padding: '12px 40px',
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          fontSize: 14,
                          fontWeight: 400,
                          color: GB_VALUE,
                          lineHeight: 1.45,
                          fontFamily: GB_FONT,
                        }}
                      >
                        <div>
                          {t("You've earned the maximum")}{' '}
                          <span style={{ fontWeight: 700, color: GB_BLUE }}>
                            {gbMaxBonusPoints.toLocaleString()} {t('Growth Bonus Points')} (${gbMaxBonusDollars.toLocaleString()})
                          </span>
                        </div>
                      </div>
                    ) : (
                      /* CHANGE 4: "next" removed so one message works at every spend level.
                         "Spend $X more to earn $500 in Growth Bonus Points" */
                      <div
                        style={{
                          background: GB_BLUE_BG,
                          borderRadius: 8,
                          padding: '12px 40px',
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          fontSize: 14,
                          fontWeight: 400,
                          color: GB_VALUE,
                          lineHeight: 1.45,
                          fontFamily: GB_FONT,
                        }}
                      >
                        {/* inner wrapper keeps the copy on two lines inside the flex box */}
                        <div>
                          {t('Spend')}{' '}
                          <span style={{ fontWeight: 700, color: GB_BLUE }}>
                            ${animatedToNext.toLocaleString()}
                          </span>{' '}
                          {t('more')}
                          <br />
                          {t('to earn')}{' '}
                          <span style={{ fontWeight: 700, color: GB_BLUE }}>
                            {t('${{bonus}} in Growth Bonus Points', { bonus: gbBonusPerMilestone })}
                          </span>
                        </div>
                      </div>
                    )}
                  </Grid>
                </Grid>

                {/* Progress bar for current segment (prev milestone -> next milestone) */}
                <div style={{ marginTop: 22 }}>
                  <div
                    style={{
                      width: '74%',
                      height: 10,
                      borderRadius: 6,
                      background: GB_TRACK,
                      overflow: 'hidden',
                      position: 'relative',
                    }}
                  >
                    <div
                      style={{
                        width: gbShowLoading ? '0%' : `${gbSegmentPct}%`,
                        height: '100%',
                        background: GB_BLUE,
                        borderRadius: 6,
                        transition: 'width 1.1s cubic-bezier(0.34, 1.56, 0.64, 1)',
                        position: 'relative',
                        overflow: 'hidden',
                      }}
                    >
                    </div>
                  </div>

                  <div style={{ width: '74%', display: 'flex', justifyContent: 'space-between', marginTop: 8 }}>
                    <span style={{ fontSize: 12, fontWeight: 400, color: GB_LABEL, fontFamily: GB_FONT }}>
                      {gbShowLoading || gbAllMilestonesReached ? '' : `$${gbSegmentStart.toLocaleString()}`}
                    </span>
                    <span style={{ fontSize: 12, fontWeight: 400, color: GB_LABEL, fontFamily: GB_FONT }}>
                      {gbShowLoading
                        ? ''
                        : gbAllMilestonesReached
                          ? `${t('Maximum')}: $${gbMaxValue.toLocaleString()}`
                          : gbNextMilestone
                            ? `${t('Next milestone')}: $${gbNextMilestone.toLocaleString()}`
                            : ''}
                    </span>
                  </div>

                  <Grid container justify="space-between" alignItems="center" style={{ marginTop: 10 }}>
                    <Grid item>
                      {/* CHANGE 6: no longer duplicates the card — shows milestone progress,
                          e.g. "0 of 21 milestones reached" */}
                      {!gbShowLoading && gbHasMilestones && (
                        <span style={{ fontSize: 13, fontWeight: 700, color: GB_BLUE, fontFamily: GB_FONT }}>
                          {t('{{reached}} of {{total}} milestones reached', {
                            reached: gbMilestonesReached,
                            total: gbTotalMilestones,
                          })}
                        </span>
                      )}
                    </Grid>
                    <Grid item>
                      <Button
                        className="gb-cta-btn"
                        onClick={()=>{
                          trackWithGTM({
                database: state?.userInfo?.loyalty_organization_name,
                event: "click",
                pathname: window.location.pathname,
                userId: state?.userInfo?.user_id,
                role_id:state?.userInfo?.role_id,
                allstate:state
              });
                          goToGrowthBonusDetails();}}
                        style={{
                          background: GB_BLUE,
                          color: '#fff',
                          textTransform: 'none',
                          fontWeight: 600,
                          fontSize: 14,
                          fontFamily: GB_FONT,
                          borderRadius: 8,
                          padding: '8px 18px',
                          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                        }}
                        endIcon={<ArrowForwardIcon style={{ fontSize: 16 }} />}
                      >
                        {t('View Growth Bonus Details')}
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </Grid>
          </Grid>
        </>
      )}

{((state?.userInfo?.role_id == 13 || state?.userInfo?.role_id == 10) && isSignature || isThrive) && (
  <BenefitMetricCard
    customerAccountNumber={state?.ACA?.customer_account_number}
    loyaltyId={loyaltyId || state?.ALA?.loyalty_id}
    program={isSignature ? 'signature' : 'thrive'}
  />
)}
    </>
  );
}